// extracted by mini-css-extract-plugin
module.exports = {"viewport":"KhcudSIRa5edZePOhx2T3Q=="};